export const QUICK_TOPIC_KEY = 'jaosve_quick_topic_v1';

export const INTEREST_PRESETS = [
  { id: 'auto-moto', label: 'AUTO-MOTO', category: 'AUTO-MOTO' },
  { id: 'business', label: 'BIZNIS', category: 'BIZNIS' },
  { id: 'politics', label: 'POLITIKA', category: 'POLITIKA' },
  { id: 'travel', label: 'PUTOVANJA', category: 'PUTOVANJA' },
  { id: 'lifestyle', label: 'LIFESTYLE', category: 'LIFESTYLE' },
  { id: 'art', label: 'UMJETNOST', category: 'UMJETNOST' }
];

const normalizeName = (value) => String(value || '').trim().toLocaleLowerCase('bs');

export const findTopicPreset = (presetId) => (
  INTEREST_PRESETS.find(preset => preset.id === presetId) || null
);

export const buildCategoryTags = (categories, categoryName, subcategories) => {
  const availableSubcategories = Array.isArray(categories?.[categoryName])
    ? categories[categoryName]
    : [];

  const wantedSubcategories = Array.isArray(subcategories)
    ? new Set(subcategories.map(normalizeName))
    : null;
  const selectedSubcategories = wantedSubcategories
    ? availableSubcategories.filter(name => wantedSubcategories.has(normalizeName(name)))
    : availableSubcategories;

  const tags = selectedSubcategories.map(name => ({
    type: 'subcategory',
    name,
    parent: categoryName
  }));

  if (!wantedSubcategories || selectedSubcategories.length === availableSubcategories.length) {
    tags.unshift({ type: 'category', name: categoryName });
  }

  return tags;
};

export const buildTopicTags = (categories, presetId) => {
  const preset = findTopicPreset(presetId);
  if (!preset) return [];
  return buildCategoryTags(categories, preset.category, preset.subcategories);
};
